module.exports = __webpack_public_path__ + "static/media/motic challenge2.3f86bca9.png";